export const normalizeNotificationData = (data) => {
  if (!data || !Array.isArray(data)) return [];
  return data.map((item) => ({
    id: item.oper_id,
    folio: item.cfiscal_codbar,
    date: item.oper_fecha,
    invoiceNumber: item.efact_descripcion || item.oper_id,
    invoiceType: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
    amount: item.oper_total,
    errorDescription: item.errtim_descripcion,
  }));
};
